import { useFormStore } from '@/stores/form'
import { useAuthStore } from '@/stores/auth'
import apiHelperService from '@/services'
import { notify } from 'notiwind'
import i18n from '@/i18n/i18n'
import client_lookups from '@/assets/json/clientLookups.json'
import { isValidEmail } from '@/composables/useRuleHandler.js'

function validEmail(value) {
  if (!value || !`${value}`.trim()) {
    return false;
  }
  return !isValidEmail(value)
}

const doNotify = (title, text, duration = 6000, group = 'error') => {
  notify(
    {
      group: group,
      title,
      text
    },
    duration
  )
}

const _setMobileNumbers = (options) => {
  const formStore = useFormStore()
  formStore.extraMap.mobileNumbers = options
}

const _resetMobileNumbers = () => {
  const formStore = useFormStore()
  formStore.extraMap.mobileNumbers = []
}

const filterSponsor = (options) => {
  const formStore = useFormStore()
  const authStore = useAuthStore()
  const { identityNumber } = authStore.user
  const { isFamilyMembersSelected } = formStore.form.values || {}
  const { application, relationships } = client_lookups
  let currentOptions = options

  if (authStore.user.applicationId != application.establishment) {
    currentOptions = currentOptions.filter((item) => item.identityNumber != identityNumber)
    if (isFamilyMembersSelected) {
      currentOptions = currentOptions.filter((item) =>
        [relationships.son, relationships.daughter].includes(item.lookupFamilyRelationshipId)
      )
      currentOptions = currentOptions.map((item) => {
        item.localizedName =
          localStorage?.global?.languageId == 2 ? item.englishName : item.arabicName
        return item
      })
    }
  }
  return currentOptions
}

function filterMobileNumbers(options) {
  let res = []
  if (Array.isArray(options)) {
    res = options
  } else {
    Object.keys(options).forEach((key) => {
      res.push(options[key])
    })
  }

  _setMobileNumbers(res)
  return res
}

const isFamilyMembersSelectedChange = (selectedVal) => {
  const formStore = useFormStore()
  formStore.form.setFieldValue('selectedSponsor', null)
  _resetMobileNumbers()

  formStore.form.setFieldValue('isLoginUserSelected', false)
  formStore.form.setFieldValue('currentEmail', null)
}

const isLoginUserSelectedChange = (selectedVal) => {
  const formStore = useFormStore()
  if (selectedVal) {
    formStore.form.setFieldValue(
      'currentEmail',
      formStore.form.values?.individualInfo?.emailAddress
    )
  } else {
    _resetMobileNumbers()
    formStore.form.setFieldValue('currentEmail', null)
  }

  formStore.form.setFieldValue('isFamilyMembersSelected', false)
  formStore.form.setFieldValue('selectedSponsor', null)
}

const requireMobileNumberEditChange = (selectedVal) => {
  const formStore = useFormStore()
  formStore.form.setFieldValue('currentMobileNumber', null)
}

const sendOtpEmail = async () => {
  const formStore = useFormStore()
  const { currentEmail, newEmail } = formStore.form.values
  try {
    if(validEmail(currentEmail) || validEmail(newEmail)) {
      formStore.extraMap.isEmailValidated = false;
      return;
    }
    const res = await apiHelperService.get(
      `/api/user/individual/email/${newEmail}/${currentEmail}/SendOtpEmailForIndividual`
    )
    doNotify(
      i18n.global.t('OTPEmailSentBody'),
      i18n.global.t('OTPEmailSentBody'),
      undefined,
      'success'
    )
  } catch (error) {
    console.error(error)
  }
}
const checkOtpEmail = async () => {
  const formStore = useFormStore()
  const { newEmail, oneTimePasswordForEmail } = formStore.form.values
  try {
    const res = await apiHelperService.get(
      `/api/user/individual/email/${newEmail}/otp/${oneTimePasswordForEmail}/validateForIndividual`
    )
    if (res?.isValid) {
      doNotify(
        i18n.global.t('otpValidatedSuccessfully'),
        i18n.global.t('otpValidatedSuccessfully'),
        undefined,
        'success'
      )
      return
    }
    doNotify(i18n.global.t('InvalidOTP'), i18n.global.t('InvalidOTP'), undefined, 'error')
  } catch (error) {
    console.error(error)
    doNotify(i18n.global.t('InvalidOTP'), i18n.global.t('InvalidOTP'), undefined, 'error')
  }
}

const requestChangeMobileOTP = async () => {
  const formStore = useFormStore()
  const { newMobileNumber } = formStore.form.values
  try {
    const res = await apiHelperService.get(
      `/api/user/individual/mobile/${newMobileNumber}/SendOtpForIndividual`
    )
    doNotify(i18n.global.t('OTPSentBody'), i18n.global.t('OTPSentBody'), undefined, 'success')
  } catch (error) {
    console.error(error)
  }
}

const checkRequestChangeMobileOTP = async () => {
  const formStore = useFormStore()
  const { newMobileNumber, oneTimePassword } = formStore.form.values

  formStore.extraMap.showSubmitButton = false
  try {
    const res = await apiHelperService.get(
      `/api/user/individual/mobile/${newMobileNumber}/otp/${oneTimePassword}/validateForIndividual`
    )
    if (res?.isValid) {
      formStore.extraMap.showSubmitButton = true

      doNotify(
        i18n.global.t('otpValidatedSuccessfully'),
        i18n.global.t('otpValidatedSuccessfully'),
        undefined,
        'success'
      )
      return
    }
    doNotify(i18n.global.t('InvalidOTP'), i18n.global.t('InvalidOTP'), undefined, 'error')
  } catch (error) {
    console.error(error)
    doNotify(i18n.global.t('InvalidOTP'), i18n.global.t('InvalidOTP'), undefined, 'error')
  }
}

const checkIsSameEmail = () => {
  const formStore = useFormStore()
  const { currentEmail, newEmail } = formStore.form.values;

  if(validEmail(currentEmail) || validEmail(newEmail)) {
    formStore.extraMap.isEmailValidated = false;
    return;
  }
  formStore.extraMap.isEmailValidated = true;

  if( currentEmail == newEmail) {
    doNotify(
      '',
      i18n.global.t('pleaseInsertDifferentEmail'),
      undefined,
      'error'
    )

    formStore.form.setFieldValue('newEmail', null)
    return
  }
}


export default function (actionName, actionParams) {
  switch (actionName) {
    case 'filterSponsor':
      return filterSponsor(actionParams)
    case 'checkIsSameEmail':
      return checkIsSameEmail(actionParams)
    case 'filterMobileNumbers':
      return filterMobileNumbers(actionParams)
    case 'isFamilyMembersSelectedChange':
      return isFamilyMembersSelectedChange(actionParams)
    case 'isLoginUserSelectedChange':
      return isLoginUserSelectedChange(actionParams)
    case 'requireMobileNumberEditChange':
      return requireMobileNumberEditChange(actionParams)
    case 'requestChangeMobileOTP':
      return requestChangeMobileOTP(actionParams)
    case 'checkRequestChangeMobileOTP':
      return checkRequestChangeMobileOTP(actionParams)
    case 'sendOtpEmail':
      return sendOtpEmail(actionParams)
    case 'checkOtpEmail':
      return checkOtpEmail(actionParams)
    default:
      break
  }
}
